export const TOGGLE_DMX_UNIVERSE_STATUS = 'TOGGLE_DMX_UNIVERSE_STATUS';
export const TOGGLE_DMX_UNIVERSE_STATUS_SUCCESSFUL = 'TOGGLE_DMX_UNIVERSE_STATUS_SUCCESSFUL';
export const TOGGLE_DMX_UNIVERSE_STATUS_FAILED = 'TOGGLE_DMX_UNIVERSE_STATUS_FAILED';
